import {forOwn} from "lodash-es";

/**
 * Create the URL query based on the parameters.
 *
 * @param params the request parameters as object
 *
 * IMPORTANT
 * Boolean values must be inserted as strings otherwise they removed from query
 *
 * @returns {string} the query url part
 */
export const createURLQuery = (params) => {
    let parameters = "";

    params && forOwn(params, function (value, key) {

        if (key) {
            let paramValue = value;

            if (Array.isArray(value)) {
                paramValue = value.length > 0 ? (value.map((v, i) => i === 0 ? v : key + "=" + v)).join("&") : undefined;
            }

            if (paramValue) {
                parameters += `${(parameters.length === 0 ? "?" : "&")}${key}=${paramValue}`;
            }
        }
    });
    return parameters;
};

export const createURLQueryFromParams = (params) => {

    Object.entries(params).forEach(([key, val]) => {
        if (!val || Array.isArray(val) && !val.join("")){
            delete params[key];
        }
    });

    // The keys of the params that are of type array
    const arrayParams = [];
    const queryParams = Object.entries(params).map(([key, val]) => {
        if (Array.isArray(val)) {
            arrayParams.push(key);
            return null;
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    });

    // Add the values of the arrays to the queryParams array
    arrayParams.forEach((arr) => {
        params[arr].forEach((arrValue) => {
            queryParams.push(`${encodeURIComponent(arr)}=${encodeURIComponent(arrValue)}`);
        });
    });

    // TODO: Replace titles with slugs and remove encodeURIComponent()
    return "?" + queryParams.filter((el) => (el !== null)).join("&");
};

export const getURLQuery = (param, url) => {
    let res;
    try {
        const name = param.replace(/[[\]]/g, "\\$&");
        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        const results = regex.exec(url);
        if(results && results[2]) {
            res = decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    } catch (error) {
        console.error(error);
    }
    return res;
};
